import * as React from 'react';
import { Instance, createPopper, Placement, Modifier } from '@popperjs/core';

interface UsePopoverParams {
  popperReference: React.RefObject<HTMLButtonElement | HTMLDivElement>;
  popperPopover: React.RefObject<HTMLDivElement>;
  popperPlacement?: Placement;
  popperOffset?: number[];
  popperModifiers?: Partial<Modifier<any, any>>[];
}

export function usePopover({
  popperReference,
  popperPopover,
  popperPlacement = 'auto',
  popperOffset = [0, 4],
  popperModifiers = [],
}: UsePopoverParams) {
  const popper = React.useRef<Instance | null>(null);

  React.useEffect(() => {
    if (popperReference.current && popperPopover.current && !popper.current) {
      popper.current = createPopper(
        popperReference.current,
        popperPopover.current,
        {
          strategy: 'absolute',
          placement: popperPlacement,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: popperOffset,
              },
            },
            ...popperModifiers,
          ],
        }
      );
    }
  }, [
    popperReference,
    popperPopover,
    popper,
    popperPlacement,
    popperOffset,
    popperModifiers,
  ]);

  return popper;
}
